import React, { useEffect, useMemo, useState } from 'react'
import { connect } from 'react-redux'
import { Switch, Box, Grid, Typography } from '@material-ui/core'
import ReactHlsPlayer from 'react-hls-player'
import RequestService from '../../services/request/request-service'
import { PACKMAN_DASHBOARD_QUERY } from '../../shared/constants/queries'
import Clock from '../../components/clock/clock-component'

import CherriesProcessedChart from './components/CherriesProcessedChart'
import InboundOutboundChart from './components/InboundOutboundChart'
import useStyles from './packman_dashboard_v2.styles'
import SingleData from '../../components/singledata/singledata.component'

const PackmanDashboardV2 = ({ currentFacility, currentMachine }) => {
  const classes = useStyles()
  const [isVideoStream, setIsVideoStream] = useState(false)
  const [dashboardData, setDashboardData] = useState({})

  const cherriesProcessedChart = useMemo(() => {
    return <CherriesProcessedChart cherriesProcessedByTime={dashboardData.cherriesProcessedByTime} />
  }, [dashboardData.cherriesProcessedByTime])

  const inboundOutboundChart = useMemo(() => {
    return <InboundOutboundChart inboundOutboundDistribution={dashboardData.inboundOutboundDistribution} />
  }, [dashboardData.inboundOutboundDistribution])

  const videoStream = useMemo(() => {
    return (
      <ReactHlsPlayer src="https://buenafrutasolutions.com/hls/live.m3u8" muted autoPlay width="100%" height="400px" />
    )
  }, [])

  const fetchDashboardData = async () => {
    try {
      const res = await RequestService.Get(PACKMAN_DASHBOARD_QUERY)
      setDashboardData(res.data)
    } catch (error) {
      console.log('error', error)
    }
  }

  useEffect(() => {
    fetchDashboardData()
  }, [])

  return (
    <div className={classes.container}>
      <Box pt={3}>
        <Grid container alignItems="center" spacing={1}>
          <Grid item xs={12} md={12}>
            <Typography component="h1" variant="h5" color="primary">
              {currentFacility.description !== '' ? currentFacility.description : currentFacility.name}
            </Typography>
            <Typography component="h1" variant="subtitle1" color="primary">
              {currentMachine.id > 0 ? (currentMachine.name ? currentMachine.name : currentMachine.description) : null}
            </Typography>
            <Clock />
          </Grid>
        </Grid>
      </Box>

      <Box pb={3} pt={3}>
        <div style={{ border: '1px solid #eee' }} />
      </Box>

      <Grid container spacing={4}>
        {/* left part */}
        <Grid item xs={12} md={6}>
          <Typography component="h1" variant="subtitle1" color="primary" gutterBottom>
            Current Viewing: {dashboardData?.currentlyViewing || ''}
          </Typography>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <SingleData title="Working Time" value={dashboardData?.workingTime || 0} />
            </Grid>
            <Grid item xs={6}>
              <SingleData title="Total Cherries" value={dashboardData?.totalCherries || 0} />
            </Grid>
            <Grid item xs={6}>
              <SingleData title="Lot#" value={dashboardData?.batchId || 0} />
            </Grid>
            <Grid item xs={6}>
              <SingleData title="Cherries Pick" value={dashboardData?.cherriesPick || 0} />
            </Grid>
            <Grid item xs={6}>
              <SingleData title="Variety" value={dashboardData?.varietyName || 0} />
            </Grid>
            <Grid item xs={6}>
              <SingleData title="Fruit per minute" value={dashboardData?.fruitPerMinute || 0} />
            </Grid>
            <Grid item xs={6}>
              <SingleData title="Grower" value={dashboardData?.growerName || 0} />
            </Grid>
            <Grid item xs={6}>
              <SingleData title="Picks per minute" value={dashboardData?.picksPerMinute || 0} />
            </Grid>
            <Grid item xs={6}>
              <SingleData title="Outlet #" value={dashboardData?.outletNumber || 0} />
            </Grid>
            <Grid item xs={6}>
              <SingleData title="Miss rate" value={`${((dashboardData?.missRate || 0) * 100).toFixed(0)}%`} />
            </Grid>
          </Grid>
          <div className={classes.videoStreamContainer}>
            <div className={classes.videoStreamHeader}>
              <Typography color="primary" component="h5" variant="h5">
                Video Stream
              </Typography>
              <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                <Typography component="h1" variant="subtitle1" color="primary">
                  Off
                </Typography>
                <Switch onChange={() => setIsVideoStream(!isVideoStream)} />
                <Typography component="h1" variant="subtitle1" color="primary">
                  On
                </Typography>
              </div>
            </div>
            <div className={classes.videoStreamBody}>
              {isVideoStream ? videoStream : <span>Video Stream will be here</span>}
            </div>
          </div>
        </Grid>

        {/* right part */}
        <Grid item xs={12} md={6}>
          <div style={{ height: '410px' }}>{cherriesProcessedChart}</div>
          <div style={{ height: '410px' }}>{inboundOutboundChart}</div>
        </Grid>
      </Grid>
    </div>
  )
}

const mapStateToProps = (state) => ({
  currentFacility: state.facility.currentFacility,
  currentMachine: state.machine,
})

const mapDispatchToProps = (dispatch) => ({})

export default connect(mapStateToProps, mapDispatchToProps)(PackmanDashboardV2)
